import { render, staticRenderFns } from "./AssignmentDetailsPdf.vue?vue&type=template&id=133f8198&scoped=true&"
import script from "./AssignmentDetailsPdf.vue?vue&type=script&lang=js&"
export * from "./AssignmentDetailsPdf.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentDetailsPdf.vue?vue&type=style&index=0&id=133f8198&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133f8198",
  null
  
)

export default component.exports